import React from 'react';
import Immutable from 'seamless-immutable';
import { TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Toast from '../Toast';

import { toast } from '../../../utils/propTypes';

import styles from './styles.scss';

function ToastContainer({ toasts }) {
  return (
    <TransitionGroup className={styles.container}>
      {toasts.map(aToast => <Toast key={aToast.id} toast={aToast} />)}
    </TransitionGroup>
  );
}

ToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(toast).isRequired,
};

function mapStateToProps({ toasts }) {
  return {
    toasts: Immutable.asMutable(toasts.toasts),
  };
}

export default connect(mapStateToProps)(ToastContainer);



// WEBPACK FOOTER //
// ./src/app/components/ToastContainer/index.js